// extracted by mini-css-extract-plugin
export default {"section":"O4eLVUHbmhUho4Hs6nAC","contact":"yRkAOCVJ9io1sfXf6PWo","contactName":"oONCV6iEdg4hnwt1IvNR","phone":"SmJoD_pmd9MIDeZD_hYD"};